import React from 'react';
import { Link } from 'react-router-dom';
import { Scissors, Building2, TrendingUp, Wallet, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useLanguage } from '../context/LanguageContext';
import LanguageSelector from '../components/LanguageSelector';

export default function Landing() {
  const { t } = useLanguage();

  const features = [
    { icon: Building2, title: t('f1t'), desc: t('f1d') },
    { icon: TrendingUp, title: t('f2t'), desc: t('f2d') },
    { icon: Wallet, title: t('f3t'), desc: t('f3d') },
  ];

  return (
    <div className="min-h-screen flex flex-col bg-background">
      {/* Top bar */}
      <header className="flex items-center justify-between px-4 sm:px-8 py-4">
        <div className="flex items-center gap-2">
          <Scissors className="w-6 h-6 text-red-500" />
          <span className="font-bold text-lg">Scherenmarket</span>
        </div>
        <div className="flex items-center gap-2">
          <LanguageSelector />
          <Link to="/login"><Button variant="ghost" size="sm">{t('landingLogin')}</Button></Link>
        </div>
      </header>

      {/* Hero */}
      <main className="flex-1">
        <section className="max-w-3xl mx-auto px-4 text-center pt-16 sm:pt-24 pb-16">
          <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-red-500 bg-red-500/10 border border-red-500/20 rounded-full px-3 py-1 mb-6">
            <Scissors className="w-3.5 h-3.5" /> {t('landingTag')}
          </div>
          <h1 className="text-4xl sm:text-6xl font-extrabold tracking-tight leading-[1.05]">
            {t('landingHead')}
          </h1>
          <p className="text-muted-foreground text-base sm:text-lg mt-6 max-w-2xl mx-auto">
            {t('landingSub')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-9">
            <Link to="/register" className="w-full sm:w-auto">
              <Button size="lg" className="w-full gap-2 text-base h-12 px-8">
                {t('landingReg')} <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
            <Link to="/login" className="w-full sm:w-auto">
              <Button size="lg" variant="outline" className="w-full text-base h-12 px-8">
                {t('landingLogin')}
              </Button>
            </Link>
          </div>
        </section>

        {/* Features */}
        <section className="max-w-4xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-3 gap-4 pb-20">
          {features.map((f, i) => {
            const Icon = f.icon;
            return (
              <div key={i} className="rounded-2xl border border-border/40 bg-gradient-to-b from-card/60 to-card/20 p-6 text-left">
                <div className="w-11 h-11 rounded-xl bg-red-500/10 text-red-500 flex items-center justify-center mb-4">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="font-semibold text-lg">{f.title}</h3>
                <p className="text-sm text-muted-foreground mt-1.5 leading-relaxed">{f.desc}</p>
              </div>
            );
          })}
        </section>
      </main>

      {/* Footer */}
      <footer className="border-t border-border/30 py-6">
        <div className="max-w-4xl mx-auto px-4 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-muted-foreground">
          <span>© {new Date().getFullYear()} Scherenmarket · {t('landingFooter')}</span>
          <div className="flex items-center gap-4">
            <Link to="/impressum" className="hover:text-foreground transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-foreground transition-colors">Datenschutz</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
